import classNames from "classnames/bind";
import styles from "./AddUser.module.css";
import { Previous } from "../../../../components/Icons/Icons";
import FormCreateUser from "./FormRegister";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../../components";

const cx = classNames.bind(styles);


function AddUser() {
    const navigate = useNavigate();

    const back = () => {
        navigate(-1)
    }

    const getError = (data) => {
        if (data) {
            Toast.open(data, "danger")
        }
    }
    return (
        <div className={cx('wrapper')}>
            <div id="__notification"></div>
            <div className={cx('header')}>
                <button onClick={back} className={cx('button-back')}>
                    <Previous />
                </button>
                <h1 className={cx('title')}>Tạo tài khoản người dùng</h1>
            </div>
            <div className={cx('contain')}>
                <FormCreateUser onBack={back} getError={getError}/>
            </div>
        </div>
    )
}

export default AddUser;